import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  site_name: "PlayZone Arena",
  tagline: "Where Fun Meets Sport",
  whatsapp_number: "94770000000",
  contact_email: "hello@playzone.com",
  contact_phone: "+94 77 000 0000",
  address: "Colombo, Sri Lanka",
  facebook_url: "",
  instagram_url: "",
  youtube_url: "",
  map_embed: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings({ ...DEFAULTS, ...data })).catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULTS, setSettings: () => {} };
